import { InteractionStatus } from "@azure/msal-browser";
import ErrorPage from "../../pages/Error/Component";
import React, { useContext } from "react";
import RdContext from "../../contexts/RdProvider";
import { RdContextType } from "../../@types/Rd";
import ApiErrorContext, { ApiErrorContextType } from "../../contexts/ApiErrorProvider";
import { IsExpiredToken, IsValidToken } from "../../Hooks/useJwtToken";
import { IUserModel } from "../../models/DTO/UserModel";
import { IUserCompanyPermissionModel } from "../../models/DTO/UserCompanyPermissionModel";

const HasCompany = (companyId: string): boolean => companyId != null && companyId != "";

const HasValidPermissionInUser = (companyId: string, userInfo?: IUserModel): boolean => userInfo?.Permissions != null && userInfo.Permissions.has(companyId) && userInfo.Permissions.get(companyId)!.HasOneValidPermission();

const HasValidPermissionByUserAndCompany = (companyId: string, Permissions: Map<string, IUserCompanyPermissionModel>, userInfo?: IUserModel): boolean => Permissions != null && userInfo != null && Permissions.has(`${userInfo.Id}|${companyId}`) && Permissions.get(`${userInfo.Id}|${companyId}`)!.HasOneValidPermission()

const IsValidUserPermission = (companyId: string, Permissions: Map<string, IUserCompanyPermissionModel>, userInfo?: IUserModel): boolean => {

    const result = HasCompany(companyId) && (HasValidPermissionInUser(companyId, userInfo) || HasValidPermissionByUserAndCompany(companyId, Permissions, userInfo));
    return result;
}

export const AuthCompanyValidityBlock = (companyName: string, isAdAuthenticated: boolean, adAuthProgress?: InteractionStatus): JSX.Element | null => {

    const { RdToken: token, inLogingProgress, currentCompany, userInfo, Permissions } = useContext<RdContextType>(RdContext),
        { ApiError, UpdateErrorState } = useContext<ApiErrorContextType>(ApiErrorContext),
        companyId: string = currentCompany?.Id?.toString() || "",
        isAdOk: boolean = adAuthProgress == InteractionStatus.None && isAdAuthenticated,
        isValidToken: boolean = token != null && token != "" && IsValidToken(token),
        isValidUserPermission: boolean = IsValidUserPermission(companyId, Permissions, userInfo),
        clearPreviouslyBlock: boolean = isAdOk && !inLogingProgress && isValidToken
            && isValidUserPermission && ApiError != null && UpdateErrorState != null
            && (ApiError.ErrorCode == 401 || ApiError.ErrorCode == 403)
            && currentCompany != null;

    if (isAdOk) {
        if (currentCompany != null && (!isValidToken || !isValidUserPermission)) {

            let message = IsExpiredToken(token) ?
                `Sua sessão na empresa "${companyName}" expirou.\nFaça login novamente para continuar (Troque de empresa).` :
                `Usuário sem permissão de login na empresa "${companyName}".\nSolicite permissão ao seu administrador!`;

            if (inLogingProgress)
                message = `Verificando permissão na empresa "${companyName}"...`;

            return <ErrorPage
                customMessage={message}
                errorCode={403}
            />
        }

        //if there was permission error previously, clear it.
        if (clearPreviouslyBlock)
            UpdateErrorState!(undefined);

    }

    return null;
}